import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { ReactComponent as Loader } from "../../../images/Loader.svg";
import { useState } from "react";
import { TablePagination } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  table: {
    // minWidth: "auto",
  },
  tableRow: {
    textDecoration: "none",
    "& > td": {
      fontWeight: "bold",
      fontSize: "1.02em",
    },
    "&:hover": {
      backgroundColor: "#5ce0d252 !important",
    },
  },
  tableHeading: {
    " & > th": {
      color: "#000 !important",
      fontWeight: "bolder",
      fontSize: "1.02em",
    },
  },
}));

const PracticeReport = ({ rows, loading }) => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setPage(0);
  };
  return (
    <div className={classes.tableContainer}>
      {!loading ? (
        <TableContainer>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow className={classes.tableHeading}>
                <TableCell align="center">No</TableCell>
                <TableCell align="center">Date</TableCell>
                <TableCell align="center">Subject</TableCell>
                <TableCell align="center">Chapter</TableCell>
                <TableCell align="center">Topic</TableCell>
                <TableCell align="center">No of Questions</TableCell>
                <TableCell align="center">Practice Time</TableCell>
                <TableCell align="center">Easy</TableCell>
                <TableCell align="center">Medium</TableCell>
                <TableCell align="center">Difficult</TableCell>
                {/* <TableCell align="center">Knowledge</TableCell>
                <TableCell align="center">Understanding</TableCell>
                <TableCell align="center">Analysis</TableCell>
                <TableCell align="center">Application</TableCell> */}
                <TableCell align="center">Class Average Score</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows && rows.length ? (
                rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow
                      // key={`${row.subject}${index}`}
                      variant="button"
                      className={classes.tableRow}
                      style={{
                        backgroundColor: index % 2 ? "#5ce0d2" : "white",
                      }}
                    >
                      <TableCell scope="row" align="center">
                        {index + 1}
                      </TableCell>
                      <TableCell scope="row" align="center">
                        {row.startedAt.split("T")[0]}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ width: "17%" }}
                        dangerouslySetInnerHTML={{
                          __html: row.subjectId.name,
                        }}
                      ></TableCell>
                      <TableCell
                        align="center"
                        style={{ width: "17%" }}
                        dangerouslySetInnerHTML={{
                          __html: row.chapterId.name,
                        }}
                      ></TableCell>
                      <TableCell
                        align="center"
                        style={{ width: "17%" }}
                        dangerouslySetInnerHTML={{
                          __html: row.topicId.name,
                        }}
                      ></TableCell>
                      <TableCell align="center">
                        {row.questionsAttempted}
                      </TableCell>
                      <TableCell align="center">
                        {Math.floor(row.timeSpend / 3600000)}h{" "}
                        {Math.floor((row.timeSpend % 3600000) / 60000)}m{" "}
                        {Math.floor((row.timeSpend / 1000) % 60)}s
                      </TableCell>
                      <TableCell align="center">{row.easy}</TableCell>
                      <TableCell align="center">{row.intermediate}</TableCell>
                      <TableCell align="center">{row.hard}</TableCell>
                      {/* <TableCell align="center">{row.hard}</TableCell>
                      <TableCell align="center">{row.hard}</TableCell>
                      <TableCell align="center">{row.hard}</TableCell>
                      <TableCell align="center">{row.hard}</TableCell> */}
                      <TableCell align="center">{row.avgScores}</TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell scope="row" align="center">
                    -
                  </TableCell>
                  <TableCell scope="row" align="center">
                    -
                  </TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                  <TableCell align="center">-</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            labelRowsPerPage={false}
            rowsPerPageOptions={false}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </TableContainer>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default PracticeReport;
